import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import { useAuth } from '../contexts/AuthContext';

// Wrapper component to use hooks in class component
const LoginWithAuth = (props) => {
  const auth = useAuth();
  return <Login {...props} auth={auth} />;
};

class Login extends Component {
  static displayName = Login.name;

  constructor(props) {
    super(props);
    this.state = {
      formData: {
        username: '',
        password: ''
      },
      errors: {},
      loading: false,
      errorMessage: ''
    };
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value
      },
      errors: {
        ...this.state.errors,
        [name]: ''
      }
    });
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.username.trim()) {
      errors.username = 'Имя пользователя обязательно';
    }

    if (!formData.password) {
      errors.password = 'Пароль обязателен';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!this.validateForm()) {
      return;
    }

    this.setState({ loading: true, errorMessage: '' });

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state.formData),
      });

      if (response.ok) {
        const loginResponse = await response.json();
        // Use auth context to store user data and token
        this.props.auth.login(loginResponse);

        // Redirect to dashboard or home page
        window.location.href = '/';
      } else {
        const errorData = await response.json();
        this.setState({
          errorMessage: errorData.message || 'Ошибка входа в систему',
          loading: false
        });
      }
    } catch (error) {
      this.setState({
        errorMessage: 'Ошибка сети. Попробуйте еще раз.',
        loading: false
      });
    }
  };

  render() {
    const { formData, errors, loading, errorMessage } = this.state;

    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md="4">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Вход в систему</h3>
              </CardHeader>
              <CardBody>
                {errorMessage && (
                  <Alert color="danger">
                    {errorMessage}
                  </Alert>
                )}
                
                <Form onSubmit={this.handleSubmit} className="login-form">
                  <FormGroup>
                    <Label for="username">Имя пользователя</Label>
                    <Input
                      type="text"
                      name="username"
                      id="username"
                      value={formData.username}
                      onChange={this.handleInputChange}
                      invalid={!!errors.username}
                      placeholder="Введите имя пользователя"
                    />
                    {errors.username && <div className="invalid-feedback">{errors.username}</div>}
                  </FormGroup>

                  <FormGroup>
                    <Label for="password">Пароль</Label>
                    <Input
                      type="password"
                      name="password"
                      id="password"
                      value={formData.password}
                      onChange={this.handleInputChange}
                      invalid={!!errors.password}
                      placeholder="Введите пароль"
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                  </FormGroup>

                  <FormGroup className="text-center">
                    <Button 
                      type="submit" 
                      color="primary" 
                      size="lg" 
                      disabled={loading}
                      block
                    >
                      {loading ? 'Вход...' : 'Войти'}
                    </Button>
                  </FormGroup>

                  <div className="text-center">
                    <p>Нет аккаунта? <a href="/register">Зарегистрироваться</a></p>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

// Export the wrapper component instead of the class component
export { LoginWithAuth as Login };
